module.exports = __webpack_public_path__ + "static/media/register.475a08a3.webp";